
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoffice/[genericRoute]/[keyword]",
      function () {
        return require("private-next-pages/debtreliefoffice/[genericRoute]/[keyword].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefoffice/[genericRoute]/[keyword]"])
      });
    }
  